@if (hasItems()) {
    <div class="item-list" data-testid="rail">
        @if (title()) {
            <div class="carousel-title pg-left cursor-pointer" (click)="onTitleClick()" data-testid="rail_title">{{ title() }}</div>
        }

        <div class="carousel-wrapper relative">
            <div #track class="carousel-track flex pg-left overflow-x-auto scroll-smooth" (scroll)="onTrackScroll()">
                @for (item of items(); track item.referenceId; let i = $index) {
                    <asset-card
                        [item]="item"
                        [attr.data-testid]="cardTestId()"
                        [attr.data-reference-id]="item.referenceId"
                        [displayFormat]="displayFormat()"
                        [size]="size()"
                        [topChart]="topChart()"
                        [showTime]="showTime()"
                        [isUpcomingCatalogue]="isUpcomingCatalogue()"
                        [index]="i"
                        [selected]="!!selectedId() && item.referenceId === selectedId()"
                        [active]="!!activeId() && item.referenceId === activeId()"
                        [removeItemConfig]="removeItemConfig()"
                        (openDetails)="onItemClick($event)"
                        (play)="play.emit($event)"
                        (stop)="stop.emit($event)">
                    </asset-card>
                }
            </div>

            @if (isSeeking()) {
                <!-- Hides the snap-into-view (and re-scroll after picking an item) behind a skeleton. -->
                <div class="absolute inset-0 z-10 overflow-hidden bg-[var(--background_primary)]">
                    <catalogue-row-skeleton [displayFormat]="displayFormat()" [size]="size()" [showTitle]="false" />
                </div>
            }

            <button type="button" class="carousel-nav nav-previous" (click)="scroll('previous')" aria-label="Previous"
                data-testid="rail_nav-prev">
                <i class="pi pi-chevron-left"></i>
            </button>
            <button type="button" class="carousel-nav nav-next" (click)="scroll('next')" aria-label="Next"
                data-testid="rail_nav-next">
                <i class="pi pi-chevron-right"></i>
            </button>
        </div>
    </div>
}
